<template>
  <div v-title data-title="查询物流" class="mobile">
    <div class="weui-flex">
      <div class="weui-flex__item">
        <wv-swipe :height="200" :autoplay="3000" class="home-banner">
          <wv-swipe-item
            v-for="(advertise, $index) in Advertises"
            :key="$index"
          >
            <div class="swipe-img-div">
              <img v-lazy="advertise" class="lazy-img-fadein" />
            </div>
          </wv-swipe-item>
        </wv-swipe>
      </div>
    </div>

    <div class="weui-flex" style="text-align: center; margin: 20px 0px 0px 0px">
      <div class="weui-flex__item">
        <button class="pickup" @click="deliverygoods">提货</button>
      </div>
      <div class="weui-flex__item">
        <button class="logistics">查物流</button>
      </div>
    </div>

    <div class="weui-cells " style="margin: 20px 0px">
       <div class="weui-cell">
        <div class="weui-cell__bd">
          <wvi-input
                    placeholder="请输入卡号"
                    ref="1"
                    v-model="model.cardNumber"
                    :validate-info="{errormsg:'卡号不可为空'}"
                    required
                ></wvi-input>
            </div>
          </div>
        <div class="weui-cell">
        <div class="weui-cell__bd">
            <wvi-input
                      placeholder="请输入手机号码"
                      ref="1"
                      v-model="model.phone"
                      :validate-info="{errormsg:'手机号码不可为空'}"
                      required
                  ></wvi-input>
              </div>
       </div>
    </div>
    <div class="weui-cell">
        <a href="javascript:;" class="btn-pickup" @click="checkCrabCard">查询物流</a>
      </div>

    <div class="weui-panel weui-panel_access">
      <div class="weui-panel__hd">注意事项</div>
      <div class="weui-panel__bd" style="padding:10px 10px;">
            <p class="weui-media-box__desc">
                1.请输入蟹卡卡号；            
            </p>
             <p class="weui-media-box__desc">
              2.请输入提卡时收货人的手机号码；
            </p>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "we-vue";
import banner1 from "@/assets/img/banner1.png";
import banner2 from "@/assets/img/banner2.png";
import banner3 from "@/assets/img/banner3.png";
import gyhdzj from "@/assets/img/gyhdzj.jpg";
const imagesList = [gyhdzj];
export default {
    name:"logistics",
    data(){
        return{
              Advertises: imagesList,
            model:{
                cardNumber:"",
                phone:""
            }
        }
    },
    created(){

    },
    methods:{
        checkCrabCard(){
           if (!this.validatesave()) {
            return;
        }
          this.$http.post(this.GLOBAL.BASE_URL + `api/crab/getlogistics?cardNumber=${this.model.cardNumber}&phone=${this.model.phone}`,{},{emulateJSON:true})
            .then(function(d){
                var rep = JSON.parse(d.bodyText);
                if (rep.Success) {
                    let data=rep.Data;
                    if(data.state){
                         this.$router.push({
                            path: "/page/logisticsdetail",
                            query: {LogisticsInfo:JSON.stringify(data.LogisticsInfo),CrabType:JSON.stringify(data.CrabType)}
                        });
                    }else{
                        Toast.fail(data.message);
                    }
                } else {
                    Toast.fail(rep.Message);
                }
            });
        },
        deliverygoods(){
            this.$router.push({path:"/page/pickup"});
        },
        validatesave: function() {
          var com = this.$refs;
          var flag = true;
          for (var c in com) {
            this.$refs[c].validate();
            flag = this.$refs[c].valid;

            if (!flag) return flag;
          }
          return flag;
        },
    }
};
</script>

<style  scoped>
.mobile{
  overflow: hidden;
}
.swipe-img-div{
    line-height: 200px;
    height: 200px;
}

.pickup {
  width: 80px;
  height: 80px;
  border-radius: 50px;
  border: none;
  background: #d5d5d6;
  font-size: 14px;
}
.logistics {
  width: 80px;
  height: 80px;
  border-radius: 50px;
  border: none;
  background: #d28a21;
  color: #fff;
  
  font-size: 14px;
}
.btn-pickup {
  width: 100%;
  background: #d28a21;
  position: relative;
  display: block;
  box-sizing: border-box;
  font-size: 14px;
  text-align: center;
  text-decoration: none;
  color: #fff;
  line-height: 2.55555556;
  border-radius: 25px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  overflow: hidden;
}
.btn-pickup :active{
    
  color: #fff;
}
.weui-media-box__desc{
    line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/crab/logistics.vue